
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/library/collection/[cid]",
      function () {
        return require("private-next-pages/library/collection/[cid].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/library/collection/[cid]"])
      });
    }
  